import { directive } from "vue-clickaway";
import "bootstrap/js/dist/tooltip";
import $ from "jquery";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", directive);
    Vue.directive("tooltip", {
      bind: (el, binding) => {
        $(el).tooltip({
          title: binding.value,
          placement: binding.arg,
          trigger: "hover"
        });
      },
      update: (el, binding) => {
        $(el).tooltip("dispose");
        $(el).tooltip({
          title: binding.value,
          placement: binding.arg,
          trigger: "hover"
        });
      },
      unbind: el => {
        $(el).tooltip("dispose");
      }
    });
  }
};

export default GlobalDirectives;
